import { render, staticRenderFns } from "./EnergoWidget.vue?vue&type=template&id=2af8efc5&scoped=true&"
import script from "./EnergoWidget.vue?vue&type=script&lang=js&"
export * from "./EnergoWidget.vue?vue&type=script&lang=js&"
import style0 from "./EnergoWidget.vue?vue&type=style&index=0&id=2af8efc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8efc5",
  null
  
)

export default component.exports